<script>
    export let text=false;
</script>

{#if text!==false}
    <small class='p-1 px-2 text-white border border-white2 rounded-1'><i class="bi bi-info-circle me-1"></i>{text}</small>
{/if}

<style>
    small {
        position:fixed;
        top:10px;
        right:10px;
        background-color: #333;
    }
</style>

